import { render, staticRenderFns } from "./CollaborationArrow.vue?vue&type=template&id=2a035ec4"
import script from "./CollaborationArrow.vue?vue&type=script&lang=js"
export * from "./CollaborationArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports